import type { ReactNode } from "react";
import { Link } from "react-router-dom";

export interface TabItem {
  key: string;
  label: ReactNode;
  to: string;
  count?: number | null;
}

/** Page tabs: scrolling pills on phones, underlined tabs from 900px. Each tab is a link, so the
    tab is part of the URL and Back returns to it. `wrap` puts tabs that don't fit on more lines
    instead of scrolling, for pages with many tabs (reports). */
export function Tabs({
  items,
  active,
  wrap,
  sub,
  label,
}: {
  items: TabItem[];
  active: string;
  wrap?: boolean;
  /** A second row: the views inside the active tab. */
  sub?: boolean;
  label?: string;
}) {
  return (
    <nav
      className={["tabs", wrap && "tabs-wrap", sub && "tabs-sub"].filter(Boolean).join(" ")}
      role="tablist"
      aria-label={label}
    >
      {items.map((t) => (
        <Link
          key={t.key}
          to={t.to}
          replace
          className={t.key === active ? "on" : undefined}
          role="tab"
          aria-selected={t.key === active}
        >
          {t.label}
          {t.count !== undefined && t.count !== null && <span className="cnt">{t.count}</span>}
        </Link>
      ))}
    </nav>
  );
}
